import Inicio from 'src/sections/@dashboard/inicio';

export default function InicioPage() {
  return <Inicio />;
}
